export default {
  name: '',
  type: '',
  dollarSpecificity: 500,
  current: '',
  starting: '',
  interest: '',
};


// WEBPACK FOOTER //
// ./src/constants/debtContract.js